import React from "react"

import { Input } from "@coval/ui/input"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { SecretInput } from "../SecretInput"
import { JsonField } from "./JsonField"
import { CHAT_WEBSOCKET_TOOLTIPS } from "./tooltips"
import type { ChatWebSocketFieldProps } from "./types"

export const ChatWebSocketDirectModeFields: React.FC<
  ChatWebSocketFieldProps
> = ({ metadata, onMetadataUpdate, disabled = false }) => {
  return (
    <>
      {/* WebSocket Endpoint (Required) */}
      <div className="space-y-2">
        <FieldLabel
          htmlFor="chat-ws-endpoint"
          tooltip={CHAT_WEBSOCKET_TOOLTIPS.endpoint}
        >
          WebSocket Endpoint
        </FieldLabel>
        <Input
          id="chat-ws-endpoint"
          aria-label="WebSocket Endpoint"
          value={metadata.endpoint || ""}
          placeholder="Enter your WebSocket endpoint"
          onChange={(e) => onMetadataUpdate({ endpoint: e.target.value })}
          disabled={disabled}
        />
      </div>

      {/* Initialization JSON (Optional for Chat WebSocket) */}
      <JsonField
        id="chat-ws-init-json"
        label="Initialization JSON"
        placeholder={
          '{\n  "action": "configureSession",\n  "deploymentId": "abc-123"\n}'
        }
        description="Optional JSON payload sent to the WebSocket immediately after connection, to configure the session on the agent's side. No message is sent if left empty."
        value={metadata.initialization_json}
        fieldName="initialization_json"
        onMetadataUpdate={onMetadataUpdate}
        disabled={disabled}
        tooltip={CHAT_WEBSOCKET_TOOLTIPS.initializationJson}
      />

      {/* Authorization Header (Optional) */}
      <div className="space-y-2">
        <FieldLabel
          htmlFor="chat-ws-auth-header"
          tooltip={CHAT_WEBSOCKET_TOOLTIPS.authorizationHeader}
        >
          Authorization Header
        </FieldLabel>
        <SecretInput
          id="chat-ws-auth-header"
          aria-label="Authorization Header"
          revealLabel="authorization header"
          value={metadata.authorization_header || ""}
          placeholder="Enter an authorization header"
          onChange={(e) =>
            onMetadataUpdate({ authorization_header: e.target.value })
          }
          disabled={disabled}
        />
      </div>

      {/* Custom Headers (Optional) */}
      <JsonField
        id="chat-ws-custom-headers"
        label="Custom Headers"
        placeholder={'{\n  "X-Coval-Simulation-Id": "{{simulation_id}}"\n}'}
        description="Additional headers to include in the WebSocket connection request."
        value={metadata.custom_headers}
        fieldName="custom_headers"
        onMetadataUpdate={onMetadataUpdate}
        disabled={disabled}
        rows={3}
        tooltip={CHAT_WEBSOCKET_TOOLTIPS.customHeaders}
      />
    </>
  )
}
